import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-multi-scan-result-modal',
  templateUrl: './multi-scan-result-modal.component.html',
  styleUrls: ['./multi-scan-result-modal.component.scss'],
})
export class MultiScanResultModalComponent implements OnInit {

  @Input() results;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    console.log(this.results);
  }

  close() {
    this.modalCtrl.dismiss();
  }

}
